module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1NDgiIGhlaWdodD0iMSIgdmlld0JveD0iMCAwIDU0OCAxIj4NCiAgPGxpbmUgaWQ9IkxpbmVfNzQ2IiBkYXRhLW5hbWU9IkxpbmUgNzQ2IiB4Mj0iNTQ4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDAuNSkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2M3YzdjNyIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtZGFzaGFycmF5PSI4Ii8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg/line-for-banner.svg
// module id = j+ah
// module chunks = 1